import React from 'react';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  popover: {
    pointerEvents: 'none',
  },
  paper: {
    backgroundColor: 'rgba(0,0,0,0.54)',
    padding: theme.spacing.unit,
  },
  inner: {
    color: 'white'
  }
});

class CustomPopover extends React.Component {
  render() {
    const { classes, handlePopoverClose, open, anchorEl, text } = this.props;

    return (
      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography className={classes.inner}>{text}</Typography>
      </Popover>
    )
  }
}

export default withStyles(styles)(CustomPopover)



// WEBPACK FOOTER //
// ./src/js/components/Mui/Popover.js